import React, { useState, useEffect } from 'react';
import UnmappedBusFlowPage from './UnmappedBusFlowPage';
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../../../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import {
  //get_admin_unmapped_bus,
  get_admin_unmapped_project_sites
  // remove_approval_delegator
} from '../../../redux/slice';

function UnmappedBusFlow() {
  TabTitle('Gift Register - Review Entry Delegator Flows');

  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const {
    // admin_unmapped_bus,
    // admin_unmapped_busPagination,
    // admin_unmapped_busLoading,
    // remove_approval_delegatorLoading
    admin_unmapped_project_sitesList,
    get_admin_unmapped_project_sitesLoading,
    pagination
  } = useSelector((state) => state.admin);

  const [radiofilter, setRadiofilter] = useState(
    JSON?.parse(window.localStorage.getItem('set_Radiofilter')) === null
      ? ''
      : JSON?.parse(window.localStorage.getItem('set_Radiofilter'))
  );
  const [triggerFilter, setTriggerFilter] = useState(false);
  const [searchRequest, setSearchRequest] = useState('');
  const [showDisablePopup, setShowDisablePopup] = useState(false);

  //console.log('searchRequest', searchRequest);
  //console.log(triggerFilter);
  //console.log('approval_delegatorsList', approval_delegatorsList);

  useEffect(() => {
    handleGetAdmin_unmapped_busList();
  }, [page, pageSize]);
  useEffect(() => {
    if (triggerFilter) {
      if (page === 1) {
        handleGetAdmin_unmapped_busList();
      } else {
        setPage(1);
      }
    }
  }, [radiofilter, searchRequest]); //page,

  const handleGetAdmin_unmapped_busList = () => {
    let payload = {
      page,
      per_page: pageSize,
      status: radiofilter,
      search: searchRequest
    };
    dispatch(get_admin_unmapped_project_sites(payload));
  };

  /* const handleChange = (e) => {
    const value = { search: e.target.value, page, status: radiofilter };
    dispatch(searchvalues(value));
  };*/
  // const handleDeleteRequest = (record) => {
  //   console.log('record', record?.record);
  //   console.log('record?.record?.delegatorId', record?.record?.delegatorId);
  //   const payload = {
  //     delegator_id: record?.record?.delegatorId,
  //     delegate_id: record?.record?.DelegateId
  //   };
  //   console.log('payload@@@@@@@@', payload);
  //   dispatch(remove_approval_delegator(payload)).then(function (response) {
  //     if (response) {
  //       handleGetAllApprovalDelegatorsList();
  //     }
  //   });
  // };
  return (
    <CustomLayout>
      <div style={{ marginTop: '50px' }}>
        <UnmappedBusFlowPage
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          radiofilter={radiofilter}
          setRadiofilter={setRadiofilter}
          setTriggerFilter={setTriggerFilter}
          admin_unmapped_bus={admin_unmapped_project_sitesList}
          admin_unmapped_busPagination={pagination}
          admin_unmapped_busLoading={get_admin_unmapped_project_sitesLoading}
          setSearchRequest={setSearchRequest}
          showDisablePopup={showDisablePopup}
          setShowDisablePopup={setShowDisablePopup}
          // handleDeleteRequest={handleDeleteRequest}
          // remove_approval_delegatorLoading={remove_approval_delegatorLoading}
        />
      </div>
    </CustomLayout>
  );
}
export default UnmappedBusFlow;
